<template>
  <div class="checkout-result-step">
    <checkout-payment-succeeded
      v-if="!errorCode"
      id="checkout-payment-succeeded"
    />
    <checkout-data-error
      v-else-if="errorCode === 400"
      id="checkout-data-error"
      @restartPayment="$emit('restartPayment')"
    />
    <checkout-payment-failed
      v-else-if="errorCode === 402"
      id="checkout-payment-error"
      @restartPayment="$emit('restartPayment')"
    />
    <checkout-coupon-error
      v-else-if="errorCode === 4"
      id="checkout-coupon-error"
    />
    <checkout-generic-error
      v-else
      id="checkout-generic-error"
      @restartPayment="$emit('restartPayment')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import appboy from 'appboy-web-sdk'

export default {
  name: 'checkout-result-step',
  props: {
    errorCode: Number
  },
  computed: mapState({ accountId: state => state.user.accountId }),
  mounted() {
    if (!this.errorCode) {
      appboy.logCustomEvent('Reached Success Page')
    } else {
      appboy.logCustomEvent('Reached Error Page')
    }
  }
}
</script>
